import React from 'react'

import { Link } from 'gatsby'
import Img from 'gatsby-image'
import 'bootstrap/dist/css/bootstrap.css';


export default function Template({ data }) {
  const post = data.markdownRemark
  
  return (
    <>
    <nav className="navbar navbar-expand-md navbar-dark bg-dark sticky-top">   
        <div className="container">
            <Link to="/" className="navbar-brand">Cj Coder</Link>
        </div>    
    </nav> 
    <div className="container-fluid">
      <hr />
      <h1>{post.frontmatter.title}</h1>
    </div>
    <div className="container">
        <div className="row">
                <div className="col-md-12">
                    <Img fluid={post.frontmatter.featuredImage.childImageSharp.fluid} />
                </div>
          </div>
      </div>
      <div className="container mt-5">
         <div className="row mt-5">
            <div className="col-md-2"></div>
            <div className="col-md-8 col-sm-12">
                <div dangerouslySetInnerHTML={{ __html: post.html }} />
                <br />
                <br />
                <br />
            </div>
            <div className="col-md-2"></div>
         </div>
         <span style={{ float: "right" }}>Posted by <b>{post.frontmatter.author}</b> on <b>{post.frontmatter.date}</b></span>
      </div>
      <footer style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
         copyright @2019
      </footer>
    </>
  )
}

export const postQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        author
        date
        SubHeading
        featuredImage {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
  `